import axios from "axios";
import { url } from "../baseUrl";

export const DashboardStore = {
  state: {
    totalusers: "",
    last_activeusers: "",
    vendor_riskscore: {},
    latestuploads: [],
    completed_lifetime: "",
    total_lifetime: "",
    riskCharts: [],
    mostcities: [],
    dates: []
  },
  mutations: {
    userStatus(state, data) {
      state.totalusers = data.total_users;
      state.last_activeusers = data.active_last_week;
    },
    riskVendors(state, data) {
      state.vendor_riskscore = data.map((item, index) => ({
        id: index + 1,
        name: item.vendor,
        value: item.count
      }));
    },
    latestUploads(state, data) {
      data.map(item => {
        let initialSubmitted = item.submit_date;
        let initialDate = initialSubmitted.split("T")[0];
        let initialTime = initialSubmitted.split("T")[1].split(".")[0];
        let date = new Date(initialDate);
        let listDate = date.toUTCString().split(" ");
        let hours = initialTime.split(":")[0];
        let mins = initialTime.split(":")[1];
        let ampm = hours >= 12 ? "p.m." : "a.m.";
        hours = hours % 12;
        hours = hours ? hours : 12;
        item.submit_date =
          listDate[2] +
          " " +
          listDate[1] +
          ", " +
          listDate[3] +
          ", " +
          hours +
          ":" +
          mins +
          " " +
          ampm;
      });
      state.latestuploads = data.map((item, index) => ({
        index: index + 1 + ".",
        id: item.id,
        description: item.file_name,
        risk_rating: item.rating,
        status: item.status,
        submitted: item.submit_date,
        vendor: item.vendor
      }));
    },
    complete_total_Lifetime(state, data) {
      state.completed_lifetime = data.completed_lifetime;
      state.total_lifetime = data.total_lifetime;
    },
    getRiskChart(state, data) {
      let risks = [];
      data.map(item => risks.push(item.count));
      state.riskCharts = risks;
    },
    getMostCities(state, data) {
      state.mostcities = data.map((item, index) => ({
        id: index + 1,
        name: item.location,
        value: item.count
      }));
    }
  },
  actions: {
    userStatus(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/usersstatus/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("userStatus", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    riskVendors(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/vendorriskscorecard/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("riskVendors", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    latestUploads(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/latestuploads/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("latestUploads", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    complete_total_Lifetime(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/scanandreports/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("complete_total_Lifetime", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getRiskChart(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/findingsgraph/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getRiskChart", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getMostCities(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/mostcommoncities/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getMostCities", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUploadsForDate(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/securitytrend/?filter=" + data.filter,
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getWorldMap(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/dashboard/worldmap/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
